var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование Подвижного состава","resource":"rolling-stocks","elements":_vm.elements,"add-message":"Подвижной состав добавлен","edit-message":"Подвижной состав изменен"},on:{"change":(payload) => _vm.isChanged = payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }